import { useCurrentChatBuyerLang } from 'hooks/business/im/chatPreference';
import { useChatConversationContext } from '../contexts/ChatConversationContext';

/**
 * 当前会话买家语言（仅限 ChatConversationProvider 内使用）
 * 在 useCurrentChatBuyerLang 基础上，补充 FACEBOOK 买家 locale / JOLECT 买家 language
 */
export const useChatBuyerLang = (conversation: Conversation.Conversation) => {
  const { facebookBuyer, jolectBuyer } = useChatConversationContext();

  const buyerLocale =
    conversation.channel === 'FACEBOOK'
      ? facebookBuyer?.locale
      : conversation.channel === 'JOLECT'
      ? jolectBuyer?.language
      : undefined;

  return useCurrentChatBuyerLang(conversation.region, conversation.channel, buyerLocale);
};
